function item(theme, ownerState) {
  const { palette, borders, functions, transitions } = theme;
  const { active, color, transparentSidenav, whiteSidenav, darkMode } = ownerState;

  const { transparent, white, grey } = palette;
  const { borderRadius } = borders;
  const { rgba } = functions;

  const hoverBg = rgba(
      (transparentSidenav && !darkMode) || whiteSidenav ? grey[400] : white.main,
      0.2
  );

  const bg = () => {
    let v = transparent.main;

    if (
        (active === "isParent" && !transparentSidenav && !whiteSidenav) ||
        (active === "isParent" && transparentSidenav && darkMode)
    ) v = rgba(white.main, 0.2);
    else if (active === "isParent" && transparentSidenav) v = grey[300];
    else if (active === "isParent" && whiteSidenav) v = grey[200];
    else if (active) v = palette[color].main;

    return v;
  };

  return {
    pl: 3,
    mt: 0.375,
    mb: 0.3,
    width: "100%",
    borderRadius: borderRadius.md,
    cursor: "pointer",
    backgroundColor: bg,
    transition: transitions.create("background-color", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.sharp,
    }),
    "&:hover, &:focus": {
      backgroundColor: !active && hoverBg,
    },
  };
}

const itemContent = (
    theme,
    {
      active,
      miniSidenav,
      nested,
      children,
      open,
      transparentSidenav,
      whiteSidenav,
      darkMode,
    }
) => {
  const { palette, functions, transitions } = theme;
  const { pxToRem, linearGradient } = functions;
  const { gradients, white, dark } = palette;

  const isLight = (transparentSidenav && !darkMode) || whiteSidenav;

  return {
    width: "100%",
    minHeight: nested ? pxToRem(38) : pxToRem(46),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: pxToRem(10),
    px: nested ? 2.5 : 1.5,
    py: nested ? 0.7 : 1,
    mx: 1,
    my: 0.35,
    borderRadius: pxToRem(14),
    cursor: "pointer",
    userSelect: "none",
    position: "relative",
    overflow: "hidden",

    color: active
        ? white.main
        : isLight
            ? dark.main
            : "rgba(255,255,255,0.86)",

    background: active
        ? linearGradient(gradients.info.main, gradients.info.state)
        : "transparent",

    boxShadow: active
        ? "0 10px 24px rgba(26, 115, 232, 0.32)"
        : "none",

    transition: transitions.create(
        ["background", "box-shadow", "transform", "color"],
        {
          duration: transitions.duration.shorter,
        }
    ),

    "&:hover": {
      background: active
          ? linearGradient(gradients.info.main, gradients.info.state)
          : darkMode
              ? "rgba(255,255,255,0.09)"
              : "rgba(255,255,255,0.12)",
      transform: "translateX(4px)",
      boxShadow: active
          ? "0 12px 28px rgba(26, 115, 232, 0.38)"
          : "0 8px 18px rgba(0,0,0,0.12)",
    },

    "&:active": {
      transform: "scale(0.98)",
    },

    "& .sidenav-icon-box": {
      minWidth: pxToRem(34),
      width: pxToRem(34),
      height: pxToRem(34),
      borderRadius: pxToRem(11),
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: pxToRem(18),

      background: active
          ? "rgba(255,255,255,0.22)"
          : darkMode
              ? "rgba(255,255,255,0.08)"
              : "rgba(255,255,255,0.14)",

      color: active
          ? white.main
          : isLight
              ? dark.main
              : white.main,

      transition: transitions.create(["background", "transform"], {
        duration: transitions.duration.shorter,
      }),
    },

    "&:hover .sidenav-icon-box": {
      transform: "scale(1.08)",
      background: active
          ? "rgba(255,255,255,0.28)"
          : "rgba(255,255,255,0.16)",
    },

    "& .MuiListItemText-root": {
      opacity: miniSidenav ? 0 : 1,
      transition: transitions.create("opacity", {
        duration: transitions.duration.shorter,
      }),
    },

    "& .MuiListItemText-primary": {
      fontSize: nested ? pxToRem(13.5) : pxToRem(15),
      fontWeight: active ? 700 : nested ? 600 : 500,
      letterSpacing: nested ? "0.1px" : "0.2px",
      color: "inherit",
      whiteSpace: "nowrap",
    },

    "& .MuiIcon-root": {
      fontSize: pxToRem(18),
      color: "inherit",
      opacity: children ? 0.75 : 0,
      transform: open ? "rotate(0deg)" : "rotate(180deg)",
      transition: transitions.create(["transform", "opacity"], {
        duration: transitions.duration.shorter,
      }),
    },

    ...(nested && {
      ml: 3,
      width: "calc(100% - 32px)",
      borderRadius: pxToRem(12),

      "&::before": {
        content: '""',
        width: pxToRem(6),
        height: pxToRem(6),
        borderRadius: "50%",
        background: active ? white.main : "rgba(255,255,255,0.5)",
        position: "absolute",
        left: pxToRem(10),
      },

      "& .MuiListItemText-root": {
        ml: 1.5,
      },
    }),
  };
};

function itemArrow(theme, ownerState) {
  const { palette, typography, transitions, breakpoints, functions } = theme;
  const { noCollapse, transparentSidenav, whiteSidenav, miniSidenav, open, active, darkMode } =
      ownerState;

  const { white, dark } = palette;
  const { size } = typography;
  const { pxToRem, rgba } = functions;

  return {
    fontSize: `${size.lg} !important`,
    fontWeight: 700,
    marginBottom: pxToRem(-1),
    transform: open ? "rotate(0)" : "rotate(-180deg)",
    color: () => {
      if (transparentSidenav && darkMode) return open || active ? white.main : rgba(white.main, 0.25);
      if (transparentSidenav || whiteSidenav) return open || active ? dark.main : rgba(dark.main, 0.25);
      return open || active ? white.main : rgba(white.main, 0.5);
    },
    transition: transitions.create(["color", "transform", "opacity"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),
    [breakpoints.up("xl")]: {
      display:
          noCollapse || (transparentSidenav && miniSidenav) || miniSidenav
              ? "none !important"
              : "block !important",
    },
  };
}

export { item, itemContent, itemArrow };
